import PropTypes from 'prop-types';
import useLocalize from '../../utils/hooks/useLocalize';
import './CannedScanCard.scss';

/**
 * CannedScanCard Component - Displays a pre-set scan card with title and description
 *
 * @param {Object} props Component props
 * @param {string} props.title The title of the scan
 * @param {string} props.description The description of the scan
 * @returns {React.Component} Canned scan card display component
 */
const CannedScanCard = ({
  scan,
  title,
  description,
  onDetailsClick,
  onClick,
  active
}) => {
  const localize = useLocalize();

  const handleDetailsClick = (e) => {
    e.stopPropagation();
    onDetailsClick?.(scan, description);
  };

  return (
    <div
      className={`canned-scan-card ${active ? 'active' : ''}`}
      onClick={onClick}
    >
      <div className="canned-scan-card-content">
        <h3 className="canned-scan-card-title">{title}</h3>
        <p className="canned-scan-card-description">{description}</p>
        <div className="canned-scan-card-footer">
          <button
            className="canned-scan-card-detail-link"
            onClick={handleDetailsClick}
            aria-label={localize('desktop.scans.more.details')}
            tabIndex={0}
            type="button"
          >
            [{localize('desktop.scans.more.details')}]
          </button>
        </div>
      </div>
    </div>
  );
};

CannedScanCard.propTypes = {
  scan: PropTypes.object,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onDetailsClick: PropTypes.func,
  onClick: PropTypes.func,
  active: PropTypes.bool
};

export default CannedScanCard;
